import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function AijentikBrain() {
  return <section className="py-32 bg-[#050505] relative z-10 border-y border-white/5 overflow-hidden" data-id="element-363">
      {/* Subtle radial warmth */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(219,127,74,0.05),transparent_70%)] pointer-events-none" data-id="element-364" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-365">
        <div className="text-center mb-20" data-id="element-366">
          <h2 className="text-4xl md:text-6xl font-display mb-6 leading-[1.0] tracking-tight text-balance text-white" data-id="element-367">
            Introducing the <br className="hidden md:block" data-id="element-368" />
            <span className="text-brand-orange" data-id="element-369">Aijentik Brain.</span>
          </h2>
          <p className="text-xl text-gray-400 font-light leading-relaxed max-w-2xl mx-auto" data-id="element-370">
            A continuously learning intelligence layer that understands your
            venue's DNA.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center max-w-5xl mx-auto" data-id="element-371">
          {/* Left: Animated Orb */}
          <div className="relative h-[400px] flex items-center justify-center" data-id="element-372">
            <motion.div animate={{
            rotate: 360
          }} transition={{
            duration: 20,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute w-64 h-64 rounded-full border border-brand-orange/20 border-dashed" data-id="element-373" />
            <motion.div animate={{
            rotate: -360
          }} transition={{
            duration: 15,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute w-48 h-48 rounded-full border border-brand-orange/40 border-dotted" data-id="element-374" />
            <motion.div animate={{
            scale: [1, 1.1, 1],
            opacity: [0.5, 1, 0.5]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute w-32 h-32 rounded-full bg-brand-orange/20 blur-xl" data-id="element-375" />
            <div className="w-24 h-24 rounded-full bg-gradient-to-br from-brand-orange to-brand-deep-orange shadow-[0_0_50px_rgba(219,127,74,0.5)] z-10" data-id="element-376" />

            {/* Orbiting particles */}
            <motion.div animate={{
            rotate: 360
          }} transition={{
            duration: 8,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute w-72 h-72" data-id="element-377">
              <div className="w-2 h-2 rounded-full bg-white absolute top-0 left-1/2 -translate-x-1/2 shadow-[0_0_10px_white]" data-id="element-378" />
            </motion.div>
          </div>

          {/* Right: Capabilities */}
          <div className="space-y-6" data-id="element-379">
            {['Learns your menus, policies, floor plan and events', 'Continuously improves with every interaction', 'Suggests operational optimisations in real time', 'Provides full explainability for every action', 'Acts autonomously OR requests human approval', 'Adapts to your tone, brand and standards'].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4" data-id="element-380">
                <div className="mt-1 bg-brand-orange/10 p-1 rounded-full shrink-0" data-id="element-381">
                  <Check className="w-4 h-4 text-brand-orange" data-id="element-382" />
                </div>
                <span className="text-gray-300 font-light" data-id="element-383">{item}</span>
              </motion.div>)}
          </div>
        </div>

        <div className="mt-24 text-center" data-id="element-384">
          <p className="text-2xl font-display text-gray-500 italic" data-id="element-385">
            "Not a tool. An intelligence."
          </p>
        </div>
      </div>
    </section>;
}